import { TARGET_TYPES } from '../../../models/target-type';
import { TargetTypeInfo } from '../../../models/target-type-info';
import { EntityTileProps } from '../../../../../layout/interfaces/tile';

export default function TargetTypeTilesFactory(targetTypes: TargetTypeInfo[]): Array<EntityTileProps> {
  return targetTypes.map((targetTypeInfo, index) => ({
    id: targetTypeInfo.type,
    sortOrder: index,
    thumbnail: targetTypeInfo.logoURL,
    darkModeThumbnail: targetTypeInfo.logoURLDarkMode,
    title: targetTypeInfo.typeDisplay,
    data: targetTypeInfo,
    metaData: TARGET_TYPES[targetTypeInfo.type] as any
  }));
}
